import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  subscription OnIntegrationConnectorRunPublished(
    $connectorId: ID!
    $tenantId: ID!
    $zoneId: ID!
  ) {
    onIntgConnectorRunPublished(
      connectorId: $connectorId
      tenantId: $tenantId
      zoneId: $zoneId
    ) {
      connectorId
      run {
        id
        startedAt
        completedAt
        error
        imports {
          path
          status
          error
        }
      }
    }
  }
`

export interface PublishedRun {
  readonly connectorId: ents.core.integrations.Connector.Id
  readonly run: Readonly<ents.core.integrations.Connector.Run>
}

const TRANSFORMER = graphql.transformers.OUT.custom<
  graphql.schema.OnIntegrationConnectorRunPublishedSubscription,
  PublishedRun
>(result => {
  const published = result.onIntgConnectorRunPublished
  TypeAsserter.assertIsNotNullish(published)
  return {
    connectorId: published.connectorId,
    run: {
      completedAt: published.run.completedAt
        ? String(published.run.completedAt)
        : undefined,
      error: published.run.error ?? undefined,
      id: published.run.id,
      imports: published.run.imports.map(importRun => ({
        error: importRun.error ?? undefined,
        path: importRun.path,
        status:
          importRun.status as ents.core.integrations.Connector.Run.Import.Status,
      })),
      startedAt: String(published.run.startedAt),
    },
  }
})

export const executor = graphql.createSubscriber<
  graphql.schema.OnIntegrationConnectorRunPublishedSubscription,
  PublishedRun,
  graphql.schema.OnIntegrationConnectorRunPublishedSubscriptionVariables
>({ query: DOC, transformer: TRANSFORMER })
